// Fixed set of icons selectable for iconListItem. Extend by adding a new
// key here — `faIcon` is used by the live Vue editor view (font-awesome-icon),
// `svg` is the static path data baked into the saved/public-page HTML output
// (renderHTML), since the public page can't depend on Font Awesome's JS/webfont.
export const ICON_LIST_ICONS = {
  info: {
    faIcon: 'info-circle',
    svg: [
      ['circle', { cx: '12', cy: '12', r: '9' }],
      ['line', { x1: '12', y1: '8', x2: '12', y2: '13' }],
      ['line', { x1: '12', y1: '16', x2: '12', y2: '16.01' }],
    ],
  },
  location: {
    faIcon: 'map-marker-alt',
    svg: [
      ['path', { d: 'M12 21s-7-6.1-7-11.5C5 5.9 8.1 3 12 3s7 2.9 7 6.5C19 14.9 12 21 12 21z' }],
      ['circle', { cx: '12', cy: '9.5', r: '2.3' }],
    ],
  },
  laptop: {
    faIcon: 'laptop',
    svg: [
      ['rect', { x: '3', y: '4', width: '18', height: '12', rx: '1.5' }],
      ['line', { x1: '8', y1: '20', x2: '16', y2: '20' }],
      ['line', { x1: '12', y1: '16', x2: '12', y2: '20' }],
    ],
  },
  certificate: {
    faIcon: 'certificate',
    svg: [
      ['circle', { cx: '12', cy: '8', r: '5' }],
      ['path', { d: 'M8.5 12.5L7 21l5-3 5 3-1.5-8.5' }],
    ],
  },
  email: {
    faIcon: 'envelope',
    svg: [
      ['rect', { x: '3', y: '5', width: '18', height: '14', rx: '2' }],
      ['path', { d: 'M3 7l9 6 9-6' }],
    ],
  },
}

export const DEFAULT_ICON = 'info'
export const ICON_KEYS = Object.keys(ICON_LIST_ICONS)
